import { api } from "./configs/axiosConfigs"

export const ProductUsageAttributeAPI = {
    
    getProductUsageAttribute: async (data:any) => {
        const response = await api.get(
            '/usageattributes', { params: {...data} }
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

    getProductUsageAttributeByCompany: async (data:any) => {
        const response = await api.get(
            '/usageattributes/listByCompany', { params: {...data} }
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

    createProductUsageAttribute: async (data: any) => {
        const response = await api.post(
            '/usageattributes/register', data
        ).then(response => response.data)
        .catch((error) => {
            console.error(error)
            return error.response.data
        })
        return response
    },

    createProductWithUsageAttribute: async (iduse:number, data: any) => {
        const response = await api.post(
            `/usageattributes/productos/${iduse}`, data
        ).then(response => response.data)
        .catch((error) => {
            console.error(error)
            return error.response.data
        })
        return response
    },
    
    editProductUsageAttribute: async (iduse: number, data: any) => {
        const response = await api.patch(
            `/usageattributes/${iduse}`, data
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },
    
    deleteProductUsageAttribute: async (iduse: number) => {
        const response = await api.delete(
            `/usageattributes/${iduse}`
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },
}